class ReadMoreButton
    constructor: (el) ->
        @.$el = el
        if !@.$el.classList.contains 'read-more-button--bound'
            @.active = @.$el.classList.contains 'read-more-button--active'

            @.$el.classList.add 'read-more-button--bound'
            @.InitEvents()
        return
    
    InitEvents: ->
        self = @
        @.$el.addEventListener 'click', (e) ->
            e.preventDefault()
            self.ToggleState()
            return
        @.$el.addEventListener 'read-more-button-toggle-state', (e) ->
            active = e.detail?.active ? null
            self.ToggleState active
            return
        return
    
    ToggleState: (active) ->
        if typeof active != "undefined" && typeof active != "null"
            @.active = active
        else
            @.active = !@.active
        if @.active
            @.$el.classList.add 'read-more-button--active'
        else
            @.$el.classList.remove 'read-more-button--active'
        @.$el.dispatchEvent new CustomEvent 'read-more-button-state-toggle', {
            bubbles: false
            detail: {
                active: @.active
            }
        }
        return

BindReadMoreButtons = ->
    document.querySelectorAll '.read-more-button:not(.read-more-button--bound)'
        .forEach (el) ->
            new ReadMoreButton el
            return
    return

window.addEventListener 'bind-components', BindReadMoreButtons